import * as React from "react";
import "./styles.scss";
import { Button } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { menu } from "../menuData";
import brandLogo from "../../assets/img/brv-logo-mark.png";

const Header = ({ onClickMenu }) => {
  return (
    <header id="header">
      <div className="inner-container">
        <a href="/#homeTop" className="brandLink" aria-label="BR&V Technology Corp">
          <div className="brand">
            <img src={brandLogo} alt="BR&V Technology Corp." />
            <span className="brandName">
              <strong>BR&V Technology</strong>
              <em>Corp</em>
            </span>
          </div>
        </a>

        <nav className="menu">
          {menu.map((item) => (
            <a key={item.link} href={item.link}>{item.title}</a>
          ))}
        </nav>

        <a className="navCta" href="/#contact">Request a Demo</a>

        <div className="mobile">
          <Button onClick={() => onClickMenu()} variant="text" aria-label="Open navigation">
            <MenuIcon />
          </Button>
        </div>
      </div>
    </header>
  );
};

export default Header;
